import { Component } from '@angular/core';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { TranslateService } from '@ngx-translate/core';
import { CartaServices } from '../../../carta/services';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { MenuServices } from '../../../menu/services';
import { getCurrencySymbol } from '@angular/common';
import { DeliberyNoteServices } from '../../../delibery_note/services';

/**
 * Component que devuelve un datetime segun lugar (espana - usa)
 *
 */

@Component({
  selector: 'create-product',
  templateUrl: 'create-product.html',
})
export class CompCreateProductPage {
  price: number = 0;
  price_static: number = 0;
  name: string = '';
  allergens = [
    {
      name: this.translate.instant('general-allergens-altramueces'),
      src: './assets/icons_100/tramusos_100.png',
      uid: '2L9I1OFi0MttudVUajCy',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-apio'),
      src: './assets/icons_100/api_100.png',
      uid: 'G3bZpwrVP9bJvlOHT6XE',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-moluscos'),
      src: './assets/icons_100/molusc_100.png',
      uid: 'l1ojIaGuVlnyWjFD6WNQ',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-sesamo'),
      src: './assets/icons_100/sesam_100.png',
      uid: 'e8v2RnYzGWTH1CboyCR7',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-gluten'),
      src: './assets/icons_100/gluten_100.png',
      uid: '50bkEzjuWbQGCB7IjrEf',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-pescado'),
      src: './assets/icons_100/peix_100.png',
      uid: 'H4W23Lv4XHx4qpZCEbYN',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-dioxido-azufre-sulfitos'),
      src: './assets/icons_100/sulfits_100.png',
      uid: 'YGkIQKw7yOfwtHq95aly',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-mostaza'),
      src: './assets/icons_100/mostassa_100.png',
      uid: 'hPrDu9pjQmqXBnoxBfet',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-crustaceos'),
      src: './assets/icons_100/crustacis_100.png',
      uid: '4VuKpxSZoGRzvNqEdIlu',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-lactosa'),
      src: './assets/icons_100/lactic_100.png',
      uid: 'Io13IxX1i5BnOpjoyZBF',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-huevo'),
      src: './assets/icons_100/ou_100.png',
      uid: '1SlpPqFfsmjec4ZnwK45',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-soja'),
      src: './assets/icons_100/soja_100.png',
      uid: 'JV8kqxMaSd1Q61cwzU9x',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-frutos-secos'),
      src: './assets/icons_100/fruitsec_100.png',
      uid: '4sKpCjitEY6sV3BhwdLq',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-cacahuetes'),
      src: './assets/icons_100/cacauet_100.png',
      uid: 'TRku0ZmxtpB3M73D8wlD',
      active: false
    },
    //indicators
    {
      name: this.translate.instant('general-indicators-vegano'),
      src: './assets/icons_100/vega_100.png',
      uid: 'WBDYCZPjlBWlXG772MLZ',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-vegetariano'),
      src: './assets/icons_100/vegetaria_100.png',
      uid: 'VxAwcxVQu7ZytAunh4pK',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-ecologico'),
      src: './assets/icons_100/eco_100.png',
      uid: 'axhqvt8l5LAG1jba2Heq',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-mediterraneo'),
      src: './assets/icons_100/mediterrani.png',
      uid: 'qOJouJQSVIEFLGdEkwRs',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-kosher'),
      src: './assets/icons_100/kosher_100.png',
      uid: 'ecE19RgQX1ze3CHY1XJi',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-cafeina'),
      src: './assets/icons_100/cafeina_100.png',
      uid: 'mGYwKe2JYwTICu7N7sC6',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-sin-azucar'),
      src: './assets/icons_100/sensesucre.png',
      uid: 'QVZO1ivcXi8gQp5o8XZf',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-stevia'),
      src: './assets/icons_100/stevia.png',
      uid: 'WMZCNDQNjlICEQ1CZzbF',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-halal'),
      src: './assets/icons_100/halal_100.png',
      uid: 'q05pas64NVItzqNNq1Nb',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-picante-suave'),
      src: './assets/icons_100/picant1.png',
      uid: 'PAhaRzeD1Fc8Eh9HurEU',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-picante'),
      src: './assets/icons_100/picant2.png',
      uid: 'SDwqJGfd8tGgWVjQnlHK',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-muy-picante'),
      src: './assets/icons_100/picant3.png',
      uid: 'kbTVLXJAOEPY4PNSgA1D',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-km0'),
      src: './assets/icons_100/km0.png',
      uid: 'FHdPZ4t2S4PjB0IlCnC5',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-comida-rapida'),
      src: './assets/icons_100/rapid.png',
      uid: 'NL0JHSeK2E4ZA9yLvzAB',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-recomendado'),
      src: './assets/icons_100/recomenat.png',
      uid: 'juWdKnYZliS2eNez9Geo',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-cerdo'),
      src: './assets/icons_100/porc_100.png',
      uid: 'jjVvcvGn3gLcMqXy4wKX',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-maiz'),
      src: './assets/icons_100/bmoro_100.png',
      uid: 'SGflJYVDgHRjeItCdim2',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-setas'),
      src: './assets/icons_100/bolets_100.png',
      uid: '6QYpvI63JK4XDqsz1995',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-alcohol'),
      src: './assets/icons_100/alcohol_100.png',
      uid: '04rgCKokhvB0BuwdWet5',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-infantil'),
      src: './assets/icons_100/infantil_100.png',
      uid: 'x0gEJ4cFaVKLaQwfybrQ',
      active: false
    }
  ];
  origin: string;
  currency: string = '';

  constructor(public dishServices: DishServices,
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    private toastCtrl: ToastController,
    public cartaServices: CartaServices,
    public navParams: NavParams,
    public analyticsServices: AnalyticsServices,
    public menuServices: MenuServices,
    public deliberyNoteServices: DeliberyNoteServices) {
    this.origin = this.navParams.get('origin');
    this.currency = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  saveElement() {
    //Comprovamos que tenga precio y nombre
    if ((this.price != null && this.price != undefined) && this.name != '') {
      //Creamos el producto y guardamos en bbdd
      this.insertProduct();
      //Lo añadimos a la array de platos seleccionados
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-completa-datos-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  activeAllergen(allergen) {
    allergen.active = !allergen.active;
  }

  allergensCss(active) {
    if (active) {
      let cssClasses = {
        'allergenSelected': true,
        'mr-1': true,
        'mb-2': true,
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'allergenSelected': false,
        'mr-1': true,
        'mb-2': true,
      }
      return cssClasses;
    }
  }

  insertProduct() {
    let active_allergens = this.allergens.filter(x => x.active == true);
    let _allergens = [];
    active_allergens.forEach(allergen => {
      _allergens.push(allergen.uid);
    });
    let _product = {
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'allergens': _allergens,
      'aiAttempts': 0,
      'name': this.name,
      'name_en': this.name,
      'name_fr': this.name,
      'name_it': this.name,
      'name_de': this.name,
      'name_ca': this.name,
      'description_es': '',
      'description_en': '',
      'description_fr': '',
      'description_it': '',
      'description_de': '',
      'description_ca': '',
      'ean': "",
      'featured': false,
      'image': '',
      'pvp': this.price,
      'pvp2': 0,
      'pvp3': 0,
      'pvp_combo_extra': 0,
      'pvp_supplement': 0,
      'pvp_takeaway': this.price,
      'price_static': this.price_static,
      'provider_static': this.translate.instant('general-sin-proveedor'),
      'providers': [{
        default: true,
        name_static: this.translate.instant('general-sin-proveedor'),
        price_static: this.price_static,
        pricetotal_static: this.price_static,
        tax_static: 4,
        uid: this.globals.no_provider.UID,
        updated_at: new Date()
      }],
      'pos_background_color': "",
      'pos_border_color': "",
      'pos_color_name': "",
      'pos_favourite': false,
      'tags': [],
      'tags_static': '',
      'tax': this.globals.RESTAURANT_TAX,
      'tpv_active': true,
      'tk_active': false,
      'observations': "",
      'measurement': 'ud.',
      'sub_recipe': false,
      'stock': 0,
      'stock_alert': 0,
      'stock_max': 0,
      'ratelimit': 0,
      'reference': "",
      'variations_favourite': [],
      'updated_user': this.globals.user_name,
      'created_at': new Date(),
      'updated_at': new Date(),
    };
    this.dishServices.afs.collection('products').add(_product).then(doc => {
      this.dishServices.dish_tags = null;
      this.globals.GAtrackView('Products', 'Products - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create name', 'Products', _product.name);
      //
      if (this.origin === 'delibery-note') {
        this.insertToDeliberyNote(_product, doc.id);
        this.close();
      } else if (this.origin == 'variations') {
        this.selectToCreateVariation(_product, doc.id);
      }
    });
  }

  insertToDeliberyNote(element, element_uid) {
    element.UID = element_uid;
    //
    var _array = Array();
    _array.push(element.UID);
    _array.push(this.globals.nameLangSelectProduct(element));
    _array.push('product');
    _array.push(element.price_static);
    _array.push(element.measurement);
    _array.push(element.tax);
    _array.push(0);
    _array.push(0);
    _array.push(0);
    _array.push(element.pvp);
    _array.push(0);
    _array.push("");
    _array.push("discount_percentage");
    this.deliberyNoteServices.prodings_array_tmp.push(_array);
    this.deliberyNoteServices.prodings_array_tmp = [...this.deliberyNoteServices.prodings_array_tmp];
    this.globals.launchToast(this.translate.instant('general-producto') + ' ' + element.name + ' ' + this.translate.instant('instant-anadido-correctemente'), 3000, 'bottom');
  }

  selectToCreateVariation(element, element_uid) {
    element.UID = element_uid;
    this.viewCtrl.dismiss(element);
  }

}


// WEBPACK FOOTER //
// ./src/pages/components/popups/create-product/create-product.ts